import "../NotificationItem/index.css";
import { Skeleton } from "@/ui-kit";

type IProps = {
  rows?: number;
};

export const NotificationsSkeleton = ({ rows = 2 }: IProps) => {
  return Array.from({ length: rows }, (_, i) => (
    <li
      key={i}
      className="notification notification--skeleton"
      aria-hidden="true"
    >
      <Skeleton width="0.625rem" height="0.625rem" shape="round" />
      <div className="notification__details">
        <Skeleton width="12.5rem" height="1.125rem" />
        <Skeleton width="6.25rem" height="0.9375rem" />
      </div>
    </li>
  ));
};
